// extracted by mini-css-extract-plugin
module.exports = {"card":"HorizontalLayout_card__2RJnO"};